import { Box } from "@outschool/backpack";
import React from "react";

import SunBackground from "../../../images/SunBackground.svg";
import { CopyOutreachLinkButton } from "./CopyOutreachLinkButton";
import { OutreachContent } from "./OutreachContent";

export function OutreachCard({
  outreachShareUrl,
  width = "300px",
  hideBoxShadow = false,
}: {
  outreachShareUrl: string;
  width?: string;
  hideBoxShadow?: boolean;
}) {
  return (
    <Box
      sx={{
        backgroundColor: "#F0F3FF",
        backgroundImage: `url("${SunBackground}")`,
        backgroundSize: "686px 635px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "-100px 170px",
        backgroundBlendMode: "normal",
        padding: "16px 20px",
        borderRadius: "16px",
        boxShadow: hideBoxShadow
          ? "none"
          : "0 16px 32px 0 #0000001A, 0 0 4px 0 #0000000A",
        width,
      }}
    >
      <OutreachContent />
      <Box sx={{ mt: "2.5rem", mb: "0.5rem" }}>
        <CopyOutreachLinkButton outreachShareUrl={outreachShareUrl} />
      </Box>
    </Box>
  );
}
